<template>
    <div class="card">
        <div class="table-responsive">
            <table class="table nowrap">
                <thead>
                    <tr>
                        <th>Sl</th>
                        <th>Name of Consultant</th>
                        <th class="text-right">Total Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(child, childIndex) in props.reportList" :key="childIndex">
                        <th>{{ childIndex + 1 }}</th>
                        <th>{{ child.consultant_name }}</th>
                        <th class="text-right">{{ child.total_count }}</th>
                    </tr>
                    <tr>
                        <th colspan="2" class="text-right">Total</th>
                        <th class="text-right">{{ totalCount(props.reportList) }}</th>
                    </tr>
                </tbody>
            </table>
          <p v-if="!props.reportList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    reportList: Array
})

const totalCount = (data) => {
    return data.reduce((sum, child) => sum + child.total_count, 0)
}
</script>

<style scoped>
    .nowrap{
        white-space: nowrap;
    }
</style>
